import { render, staticRenderFns } from "./funding-type.vue?vue&type=template&id=00942f3c"
import script from "./funding-type.component.ts?vue&type=script&lang=ts&external"
export * from "./funding-type.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports